export type CreditPolicyOperationKind = 'constitution' | 'settlement' | 'bank' | 'cash';

export interface CreditPolicyOperationRequest {
  kind: CreditPolicyOperationKind;
  movementType?: number;
  editUid?: string;
}

export interface CreditPolicyRow {
  uid: string;
  accountingModelsNumber: string;
  banco: string;
  bic: string;
  iban: string;
  limite: number;
  dispuesto?: number;
  disponible?: number;
  connected: boolean | null;
  projectUid?: string;
  expenseProjectTypeUid?: string;
  __expanded?: boolean;
}

export const CREDIT_POLICY_BANK_MOVEMENT = {
  traspaso: 1,
  transferencia: 2,
};

export const CREDIT_POLICY_CASH_MOVEMENT = {
  reintegro: 1,
  ingreso: 2,
};

export function creditPolicyOperationTitle(kind: CreditPolicyOperationKind, movementType?: number): string {
  if (kind === 'constitution') return 'Constitución de la póliza';
  if (kind === 'settlement') return 'Liquidaciones de la póliza';
  if (kind === 'bank') return movementType === CREDIT_POLICY_BANK_MOVEMENT.transferencia ? 'Transferencia' : 'Traspaso';
  return movementType === CREDIT_POLICY_CASH_MOVEMENT.ingreso ? 'Ingreso de efectivo' : 'Reintegro de efectivo';
}

export function creditPolicyOperationIcon(kind: CreditPolicyOperationKind, movementType?: number): string {
  if (kind === 'constitution') return 'account_balance';
  if (kind === 'settlement') return 'receipt';
  if (kind === 'bank') return movementType === CREDIT_POLICY_BANK_MOVEMENT.transferencia ? 'send' : 'swap_horiz';
  return movementType === CREDIT_POLICY_CASH_MOVEMENT.ingreso ? 'account_balance_wallet' : 'local_atm';
}

export function creditPolicyUsedAmount(dispuesto: number | null | undefined): number {
  const value = Number(dispuesto) || 0;
  return value < 0 ? Math.abs(value) : 0;
}
